import { writable } from "svelte/store";
export const WEBSOCKET_URL = window.location.href.includes("andreasdk.hopto.me")
    ? "wss://andreasdk.hopto.me/othello/ws"
    : "ws://127.0.0.1:3030/";
export const BOARD_SIZE = 8;
const initialState = {
    mySide: null,
    lobbyId: null,
    displayLobbyId: null,
    currentPage: "menu",
    currentTurn: null,
    connection: null,
    autoTurn: false,
};
// todo remove this
function handleKey(event) {
    if (event.key === "l") {
        state.update((state) => {
            console.log("autoturn:", !state.autoTurn);
            return Object.assign(Object.assign({}, state), { autoTurn: !state.autoTurn });
        });
    }
}
document.body.addEventListener("keydown", handleKey);
// console.log(navigator.userAgent);
// if (navigator.userAgent.toLowerCase().includes("firefox")) {
//     initialState.autoTurn = true;
// }
// initialState.autoTurn = true;
export const state = writable(initialState);
// let lastState;
state.subscribe((state) => (window["state"] = state));
// state.subscribe((state) => console.trace(state));
